import { useState, useEffect } from "react";

export const useTerminalTheme = () => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const saved = localStorage.getItem("terminal-theme");
    if (saved) {
      return saved === "dark";
    }
    // Use system preference if no saved preference
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  });

  // Listen for system theme changes
  useEffect(() => {
    const handleSystemThemeChange = (e: MediaQueryListEvent) => {
      // Only apply system theme if user hasn't made a manual choice
      if (!localStorage.getItem("terminal-theme")) {
        setIsDarkMode(e.matches);
      }
    };

    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    mediaQuery.addEventListener("change", handleSystemThemeChange);

    return () => {
      mediaQuery.removeEventListener("change", handleSystemThemeChange);
    };
  }, []);

  // Save theme preference
  useEffect(() => {
    if (localStorage.getItem("terminal-theme")) {
      localStorage.setItem("terminal-theme", isDarkMode ? "dark" : "light");
    }
  }, [isDarkMode]);

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
    localStorage.setItem("terminal-theme", !isDarkMode ? "dark" : "light");
  };

  return {
    isDarkMode,
    toggleTheme,
  };
};
